export enum AvailabilityType {
    INOPERATIVE = 'Inoperative',
    OPERATIVE = 'Operative'
}